import React from "react";

const WidgetSetting = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M2 9.176C2 5.766 4.786 3 8.222 3c3.437 0 6.222 2.765 6.222 6.176 0 3.412-2.785 6.177-6.222 6.177C4.786 15.353 2 12.588 2 9.176Zm30.222 1.765H18v-3.53h14.222v3.53ZM21.556 26.823c0-3.41 2.785-6.176 6.222-6.176 3.436 0 6.222 2.765 6.222 6.177C34 30.233 31.214 33 27.778 33c-3.437 0-6.222-2.765-6.222-6.177ZM18 25.06v3.53H3.778v-3.53H18Z"
        />
    </svg>
);

export default WidgetSetting;
